import React from 'react'
import PropTypes from 'prop-types'
import { InstantSearch } from 'react-instantsearch/dom'
import AlgoliaUtils from 'infra/AlgoliaUtils'
import CustomerSelector from './CustomerSelector'
import ContactSelector from './ContactSelector'
import { CustomerLabel } from './CustomerAccessories'
import AddCustomerDialog from './CustomerInterfaces/AddCustomerDialog'

import Utils from './Utils'
import { connect } from 'react-redux'

const wrapWithCustomerSelection = (Component, options) => {

  class CustomerSelectionWrappedComponent extends React.Component {

    static propTypes = {
      customer: PropTypes.shape(),
      customerId: PropTypes.string,
      contactId: PropTypes.string,
      teamId: PropTypes.string
    }

    constructor(props){
      super(props)

      this.options = options || {}
      this.state = {
        showCustomerPopover: false,
        showContactPopover: false,
        showCustomerAddDialog: false,
        customer: props.customer ? Utils.normalizeCustomer(props.customer, props.customerId) : undefined,
        contact: undefined,
        contactId: props.contactId,
        customerId: props.customerId
      }
    }

    handleInputClicked = (type) => {
      if (type === 'customer'){
        this.setState({
          showCustomerPopover: !this.state.showCustomerPopover,
          showContactPopover: false
        })
      } else if (type === 'contact'){
        this.setState({
          showContactPopover: !this.state.showContactPopover,
          showCustomerPopover: false
        })
      }
    }

    onCloseRequest = (type) => {
      if (type === 'customer'){
        this.setState({ showCustomerPopover: false })
      } else if (type === 'contact'){
        this.setState({ showContactPopover: false })
      }
    }

    onCustomerSelection = (customer) => {
      const newState = {}

      newState['customer'] = Utils.normalizeCustomer(customer, customer.objectID)
      newState['customerId'] = customer.objectID
      if (this.state.customerId !== newState.customerId){
        //reset contact during customer change
        newState['contact'] = undefined
        newState['contactId'] = ''
      }
      newState['showCustomerPopover'] = false
      this.setState(newState)
    }

    onContactSelection = (customer, contact) => {
      this.setState({
        //update customer, if in case it wasn't passed in as props
        customer: Utils.normalizeCustomer(customer, this.state.customerId),
        contact,
        contactId: contact.id,
        showContactPopover: false
      })
    }

    handleAddCustomerRequest = () => {
      this.setState({
        showCustomerAddDialog: !this.state.showCustomerAddDialog,
        showContactPopover: false,
        showCustomerPopover: false
      })
    }

    handleAddNewCustomer = (customerId, contactId, customer) => {
      this.setState({
        showCustomerAddDialog: false,
        customerId,
        contactId,
        contact: customer.contactsList[contactId],
        customer: Utils.normalizeCustomer(customer, customerId)
      })
    }

    render(){
      const algoliaCredentials = AlgoliaUtils.getCredentials()
      const { customer, contact, contactId, customerId, showContactPopover, showCustomerPopover } = this.state
      const { teamId } = this.props
      const editableColor = 'rgba(0, 0, 0, 0.6)'
      return (
        <InstantSearch
          className=".ais-InstantSearch__root"
          appId={algoliaCredentials.appId}
          apiKey={algoliaCredentials.apiKey}
          indexName={`${teamId}-customers`}>

          {
            this.options.showLabel
            &&
            <CustomerLabel label={this.options.customerLabel} color={editableColor}/>
          }

          <div style={{flexDirection: 'row'}}>
            <input
              ref={e => { this.customerInput = e }}
              placeholder={'Select Customer'}
              style={styles.input}
              value={customer && customer.name}
              onClick={this.handleInputClicked.bind(this, 'customer')}
              readOnly={true}/>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              style={{ cursor: 'pointer' }}
              width="20"
              height="20"
              viewBox="0 0 18 18"
              onClick={this.handleInputClicked.bind(this, 'customer')}>
              <path d="M5 8l4 4 4-4z" fill={editableColor}/>
            </svg>
          </div>

          <CustomerSelector
            open={showCustomerPopover}
            anchorElement={this.customerInput}
            onSelection={this.onCustomerSelection}
            onCloseRequest={this.onCloseRequest.bind(this, 'customer')}
            addCustomer={this.handleAddCustomerRequest}/>

          <ContactSelector
            teamId={teamId}
            customerId={customerId}
            contactId={contactId}
            customer={customer}
            showPopover={showContactPopover}
            showLabel={this.options.showLabel}
            label={this.options.contactLabel}
            onInputClick={this.handleInputClicked.bind(this, 'contact')}
            onCloseRequest={this.onCloseRequest.bind(this, 'contact')}
            onSelection={this.onContactSelection}/>

          <Component
            {...this.props}
            contactId={contactId}
            customerId={customerId}
            contact={contact}
            customer={customer}/>

          <AddCustomerDialog
            open={this.state.showCustomerAddDialog}
            teamId={this.props.teamId}
            onSave={this.handleAddNewCustomer}
            onCloseRequest={this.handleAddCustomerRequest}/>
        </InstantSearch>
      )
    }
  }

  function mapStateToProps(state) {
    const teamId = state.firebase.team.metadata.value.id
    const userId = state.firebase.userAuth.id
    return { userId, teamId }
  }

  return connect(mapStateToProps)(CustomerSelectionWrappedComponent)
}

export default wrapWithCustomerSelection

const styles = {
  input: {
    fontSize: 14,
    padding: '7px 11px 7px 11px',
    color: '#4a4a4a',
    borderRadius: 4,
    border: 'solid 1px #e6e8ed',
    outlineWidth: 2,
    width: 275,
    cursor: 'pointer',
    marginBottom: 16
  }
}



// WEBPACK FOOTER //
// ./src/customer/CustomerSelectionWrapper.js